import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col
} from "reactstrap";
import { toast } from "react-toastify";
import { addPaymentApi } from "../../../api/apiUrlConst";
import { toWords } from "number-to-words";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  enqFormId: number;
  pendingAmount: number;
  onSuccess: () => void;
}

const AddPaymentModal: React.FC<Props> = ({
  isOpen,
  toggle,
  enqFormId,
  pendingAmount,
  onSuccess
}) => {
  const [form, setForm] = useState({
    amount: "",
    mode: "",
    account: "",
    transactionId: "",
    nextDueDate: ""
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const amountNumber = Number(form.amount);

      if (amountNumber > pendingAmount) {
        toast.error("Amount exceeds pending amount");
        return;
      }

      await addPaymentApi({
        enqFormId,
        amount: amountNumber,
        mode: form.mode,
        account: form.account,
        transactionId: form.transactionId,
        nextDueDate:
          amountNumber < pendingAmount
            ? form.nextDueDate || null
            : null
      });

      toast.success("Payment added successfully");
      toggle();
      onSuccess();
    } catch (error: any) {
      toast.error(error.response?.data || "Payment failed");
    }
  };

  return (
    <Modal
  isOpen={isOpen}
  toggle={toggle}
  centered
  contentClassName="border-0 shadow-lg"
>
  {/* ===== HEADER ===== */}
  <ModalHeader
    toggle={toggle}
    style={{
      background: "linear-gradient(90deg, #131163, #16147e)",
      color: "#fff",
      fontWeight: 600,
      borderTopLeftRadius: "1px",
      borderTopRightRadius: "1px"
    }}
  >
    💳 Add Payment
  </ModalHeader>

  {/* ===== BODY ===== */}
  <ModalBody style={{ background: "#f8f9fc", padding: "25px" }}>
    <Form className="d-flex flex-column gap-3">

      {/* Amount */}
     <FormGroup>
  <Label className="fw-semibold">Amount *</Label>

  {/* Input Wrapper */}
  <div className="position-relative">
    <span
      style={{
        position: "absolute",
        top: "50%",
        left: "15px",
        transform: "translateY(-50%)",
        fontWeight: 600,
        color: "#495057"
      }}
    >
      ₹
    </span>

    <Input
      type="number"
      name="amount"
      value={form.amount}
      onChange={handleChange}
      className="rounded-pill shadow-sm ps-5"
      placeholder="Enter amount"
    />
  </div>

  {/* 👇 Amount in Words (Now Properly Aligned) */}
  {form.amount && (
    <div
      className="mt-2 px-3 py-2"
      style={{
        background: "#f1f3f5",
        borderRadius: "12px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#495057",
      }}
    >
      {toWords(Number(form.amount))} Rupees Only
    </div>
  )}
</FormGroup>

      {/* Mode & Account */}
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Payment Mode *</Label>
            <Input
              type="select"
              name="mode"
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Mode</option>
              <option>Cash</option>
              <option>UPI</option>
              <option>Bank Transfer</option>
              <option>Card</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={6}>
         <FormGroup>
  <Label className="fw-semibold">Account</Label>
  <Input
    type="select"
    name="account"
    value={form.account || ""}
    onChange={handleChange}
    className="rounded-pill shadow-sm"
  >
    <option value="">Select Account</option>
    <option value="Wocons">Wocons</option>
    <option value="WCS">WCS</option>
    <option value="Feesworth">Feesworth</option>
  </Input>
</FormGroup>
        </Col>
      </Row>

      {/* Transaction ID */}
      <FormGroup>
        <Label className="fw-semibold">Transaction ID *</Label>
        <Input
          type="text"
          name="transactionId"
          onChange={handleChange}
          className="rounded-pill shadow-sm"
          placeholder="Enter transaction reference"
        />
      </FormGroup>

      {/* Next Due */}
      <FormGroup>
        <Label className="fw-semibold">
          Next Due Date (if partial)
        </Label>
        <Input
          type="date"
          name="nextDueDate"
          onChange={handleChange}
          className="rounded-pill shadow-sm"
        />
      </FormGroup>

    </Form>
  </ModalBody>

  {/* ===== FOOTER ===== */}
  <ModalFooter
    style={{
      background: "#f8f9fc",
      borderTop: "none",
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px"
    }}
  >
    <Button
      color="secondary"
      outline
      onClick={toggle}
      className="rounded-pill px-4"
    >
      Cancel
    </Button>

    <Button
      onClick={handleSubmit}
      className="rounded-pill px-4"
      style={{
        background: "linear-gradient(90deg,#131163, #16147e)",
        border: "none",
        fontWeight: 600
      }}
    >
      Save Payment
    </Button>
  </ModalFooter>
</Modal>
  );
};

export default AddPaymentModal;